export default __webpack_public_path__ + "static/media/element_spec_6.5b4a1896.webp";